export default __webpack_public_path__ + "app/build/static/media/bus_interior.15de21e4.png";